import { FooterColumn, FooterContent } from './types';

export const css = `
  .page-footer {
    background: var(--c-primary-8);
    color: var(--c-primary-0);

    .social-icon {
      background: var(--c-primary-7);
    }

    h3::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 3px;
      background-color: var(--c-accent-4);
    }

    .footer-link:hover {
      color: var(--c-accent-3);
      opacity: 100;
      transform: translateX(0.25rem);
    }
  }
`;

function FooterColumn({ data }: { data: FooterColumn }) {
  return (
    <div class="footer-links">
      <h3 class="text-lg font-bold mb-7 pb-3 relative">{data.title}</h3>
      <ul class="space-y-4">
        {data.links.map((link) => (
          <li key={link.id}>
            <a
              href={link.href}
              class="footer-link inline-flex items-center text-inherit opacity-80 transition-all"
            >
              {link.icon && <span class="mr-2">{link.icon}</span>}
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function View({ data }: { data: FooterContent }) {
  return (
    <footer class="page-footer py-20 text-base">
      <div class="max-w-7xl mx-auto px-8">
        <div class="grid md:grid-cols-4 gap-16">
          {/* About Column */}
          <div>
            <a href={data.logo.href} class="text-2xl font-bold mb-5 block text-inherit">
              {data.logo.text}
            </a>
            <p class="mb-8 leading-relaxed opacity-80">{data.about.description}</p>
            <div class="flex gap-4">
              {data.about.socialLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  class="social-icon size-10 rounded-full flex items-center justify-center text-inherit"
                  aria-label={link.label}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Other Columns */}
          {data.columns.map((column) => (
            <FooterColumn key={column.id} data={column} />
          ))}
        </div>

        {/* Copyright */}
        <div class="footer-copyright opacity-75 mt-16 pt-8 text-center border-t">
          {data.copyright}
        </div>
      </div>
    </footer>
  );
}
